/**
 * frame_poll_controller.js — reload a turbo-frame on an interval (Stimulus).
 *
 * Put on a <turbo-frame> that has a `src`; it calls the frame's reload()
 * every `interval` milliseconds while connected, so the frame's own endpoint
 * re-renders just that region.
 *
 * Values: interval (milliseconds).
 *
 * Templates: templates/admin/_ops_workers.html
 */

import { Controller } from "@hotwired/stimulus";

export default class extends Controller {
    static values = { interval: Number };

    connect() {
        this._timer = setInterval(() => this.element.reload(), this.intervalValue);
    }

    disconnect() {
        clearInterval(this._timer);
    }
}
